/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable */

import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { CustomCheckBox, RegularButton, ICommonDropdownOption, AlertAdapter, CommonDropdown } from 'pg-ui-library';
import { IUser } from 'src/interfaces';
import { useUpdateuser } from '../../mutations/user-setting.mutation';
import {
  ModalContent,
  AllContent,
  Header,
  MainContent,
  ModuleContainer,
  ModuleItem,
  CheckboxHeading,
  ModuleItemLabel,
  StatusContainer,
  StatusLabel,
  Footer,
} from './styles';

export const activeOptions: ICommonDropdownOption[] = [
  {
    key: 'false',
    label: 'Inactive',
    value: 'false',
  },
  {
    key: 'true',
    label: 'Active',
    value: 'true',
  },
];

export const UserEditModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  user: IUser;
  onSuccess: () => void;
}> = ({ isOpen, setIsOpen, user, onSuccess }) => {
  const updateUser = useUpdateuser();
  const formik = useFormik({
    initialValues: {
      userId: user?.id,
      isActive: user?.isActive ? 'true' : 'false',
      permission: {
        benefits: user?.permissionsUser.benefits || false,
        documents: user?.permissionsUser.documents || false,
        tax_forms: user?.permissionsUser.tax_forms || false,
        pay_history: user?.permissionsUser.pay_history || false,
        hr_profile: user?.permissionsUser.hr_profile || false,
        admin: user?.permissionsUser.admin || false,
        invoice: user?.permissionsUser.invoice || false,
        expense: user?.permissionsUser.expense || false,
        timesheet: user?.permissionsUser.timesheet || false,
        leave: user?.permissionsUser.leave || false,
      },
    },
    validationSchema: yup.object().shape({
      permission: yup.object().shape({
        benefits: yup.boolean(),
        documents: yup.boolean(),
        tax_forms: yup.boolean(),
        pay_history: yup.boolean(),
        hr_profile: yup.boolean(),
        invoice: yup.boolean(),
        admin: yup.boolean(),
      }),
    }),
    onSubmit: async values => {
      const updatedValues = {
        ...values,
        isActive: values.isActive === 'true',
      };
      try {
        await updateUser.mutateAsync({ updateUser: updatedValues });
        AlertAdapter('Updated successfully', 'success');
        setIsOpen(false);
        if (onSuccess) onSuccess();
      } catch (error) {
        const errorMsg = error?.toString() || 'An error occurred while updating the user';
        AlertAdapter(errorMsg, 'error');
      }
    },
  });

  useEffect(() => {
    if (user) {
      formik.setValues({
        isActive: user?.isActive ? 'true' : 'false',
        userId: user.id,
        permission: {
          benefits: user.permissionsUser.benefits,
          documents: user.permissionsUser.documents,
          tax_forms: user.permissionsUser.tax_forms,
          pay_history: user.permissionsUser.pay_history,
          hr_profile: user.permissionsUser.hr_profile,
          invoice: user.permissionsUser.invoice,
          admin: user.permissionsUser.admin,
          expense: user?.permissionsUser.expense,
          timesheet: user?.permissionsUser.timesheet,
          leave: user?.permissionsUser.leave,
        },
      });
    }
  }, [user]);
  // console.log('user', user);
  useEffect(() => {
    console.log('FORMIK PERMISSIONS:', formik.values.permission);
  }, [formik.values.permission]);

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={() => setIsOpen(false)}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '760px',
          height: '450px',
          // height: 'auto',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '0',
          background: '#F3F4F8',
          // overflowY: 'hidden',
        },
      }}
    >
      <ModalContent>
        <Header>
          <h3>Edit User</h3>
        </Header>
        <AllContent>
          <MainContent>
            <ModuleContainer>
              <ModuleItemLabel>Module</ModuleItemLabel>
              <ModuleItem>
                <CustomCheckBox
                  id="benefits"
                  label=""
                  name="permission.benefits"
                  checked={formik.values.permission.benefits}
                  onChange={() => formik.setFieldValue('permission.benefits', !formik.values.permission.benefits)}
                />
                <CheckboxHeading>Benefits</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  id="pay_history"
                  label=""
                  name="pay_history"
                  checked={formik.values.permission.pay_history}
                  onChange={() => formik.setFieldValue('permission.pay_history', !formik.values.permission.pay_history)}
                />
                <CheckboxHeading>Pay History</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  id="admin"
                  label=""
                  name="admin"
                  checked={formik.values.permission.admin}
                  onChange={() => formik.setFieldValue('permission.admin', !formik.values.permission.admin)}
                />
                <CheckboxHeading>Admin</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  id="hr_profile"
                  label=""
                  name="hr_profile"
                  checked={formik.values.permission.hr_profile}
                  onChange={() => formik.setFieldValue('permission.hr_profile', !formik.values.permission.hr_profile)}
                />
                <CheckboxHeading>HR Profile</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  id="documents"
                  label=""
                  name="permission.documents"
                  checked={formik.values.permission.documents}
                  onChange={() => formik.setFieldValue('permission.documents', !formik.values.permission.documents)}
                />
                <CheckboxHeading>Documents</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  label=""
                  id="tax_forms"
                  name="tax_forms"
                  checked={formik.values.permission.tax_forms}
                  onChange={() => formik.setFieldValue('permission.tax_forms', !formik.values.permission.tax_forms)}
                />
                <CheckboxHeading>Tax Forms</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  label=""
                  id="leave"
                  name="permission.leave"
                  checked={formik.values.permission.leave}
                  onChange={() => formik.setFieldValue('permission.leave', !formik.values.permission.leave)}
                />
                <CheckboxHeading>Leave</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  label=""
                  id="invoice2"
                  name="permission.invoice"
                  checked={formik.values.permission.invoice}
                  onChange={() => formik.setFieldValue('permission.invoice', !formik.values.permission.invoice)}
                />
                <CheckboxHeading>Invoice</CheckboxHeading>
              </ModuleItem>
              <ModuleItem>
                <CustomCheckBox
                  label=""
                  id="expense2"
                  name="permission.expense"
                  checked={formik.values.permission.expense}
                  onChange={() => formik.setFieldValue('permission.expense', !formik.values.permission.expense)}
                />
                <CheckboxHeading>Expense</CheckboxHeading>
              </ModuleItem>
            </ModuleContainer>
            <StatusContainer>
              <StatusLabel>Status</StatusLabel>
              <div style={{ minWidth: '100%', marginTop: '10%' }}>
                <CommonDropdown
                  label=""
                  id="isActive"
                  name="isActive"
                  options={activeOptions}
                  value={formik.values.isActive}
                  setValue={(value: string) => formik.setFieldValue('isActive', value)}
                  selectStyle={{
                    width: '100%',
                    marginTop: '8px',
                    height: 'auto',
                  }}
                />
              </div>
            </StatusContainer>
          </MainContent>
          <Footer>
            <RegularButton
              type="button"
              onClick={() => setIsOpen(false)}
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
            >
              Cancel
            </RegularButton>
            <RegularButton
              type="submit"
              onClick={() => formik.handleSubmit()}
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Save
            </RegularButton>
          </Footer>
        </AllContent>
      </ModalContent>
    </ReactModal>
  );
};
